import { render, staticRenderFns } from "./ProductReviewForm.vue?vue&type=template&id=2623ba1b&"
import script from "./ProductReviewForm.vue?vue&type=script&lang=ts&"
export * from "./ProductReviewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports